import React from 'react';
import { connectToCollections } from './containers/CollectionsDataStore';
import { Modal, Form, Input } from 'antd';
import combineConnectors from '../util/combineConnectors';
import { connectToTitle } from '../Title/containers/TitleDataStore';
import CommunityButton from '../UI/CommunityButton';
import { connectToCatalog } from './containers/CatalogDataStore';

const CollectionCreateForm = Form.create({ name: 'form_in_modal' })(
	// eslint-disable-next-line
	class extends React.Component {
		render() {
			const {
				visible,
				onCancel,
				onCreate,
				form,
				defaultValue,
				catalogId,
				name,
				sku,
				skus,
			} = this.props;
			const { getFieldDecorator } = form;
			return (
				<Modal
					defaultValue={defaultValue}
					visible={visible}
					title={
						catalogId == 0
							? 'Create New Stack / Collection'
							: 'Edit Stack / Collection Name'
					}
					okText={catalogId == 0 ? 'Create' : 'Update'}
					onCancel={onCancel}
					zIndex={10000}
					onOk={onCreate}>
					<Form layout="vertical">
						<Form.Item label="Collection Name">
							{getFieldDecorator('name', {
								rules: [
									{
										required: true,
										message: 'Please enter a name',
									},
								],
								initialValue: name,
							})(<Input />)}
						</Form.Item>
					</Form>
					{(sku || skus) &&
						"The title(s) you've selected will automatically be added to this collection once it's created"}
				</Modal>
			);
		}
	},
);

export class AddEditCollection extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			catalogId: 0,
			name: '',
			visible: false,
		};
	}

	showModal = (catalogId, name) => {
		this.setState({
			visible: true,
			catalogId: catalogId,
			name: name,
		});
	};

	handleCancel = () => {
		this.setState({ visible: false });
	};

	handleCreate = () => {
		const form = this.formRef.props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			if (this.state.catalogId === 0) {
				this.createNewCollection(values);
			} else {
				this.editExistingCollection(values);
			}
			form.resetFields();
			this.setState({ visible: false });
		});
	};

	createNewCollection = values => {
		var skus = [];
		if (this.props.sku) {
			skus.push(this.props.sku);
		} else if (this.props.skus) {
			skus = this.props.skus;
		}
		if (!this.props.sku && !this.props.skus) {
			this.props.collectionsDataStore.createNewCollection(
				values.name,
				skus,
			);
		} else {
			this.props.collectionsDataStore
				.createNewCollection(values.name, skus)
				.then(() => {
					this.props.titleDataStore &&
						this.props.titleDataStore.refreshCollectionData();
				});
		}
	};

	editExistingCollection = values => {
		this.props.collectionsDataStore
			.editExistingCollection(this.props.catalogId, 'Name', values.name)
			.then(() => {
				this.props.catalogStore && this.props.catalogStore.refresh();
			});
	};

	saveFormRef = formRef => {
		this.formRef = formRef;
	};

	render() {
		const { catalogId, name, sku, skus } = this.props;
		return (
			<React.Fragment>
				<CollectionCreateForm
					wrappedComponentRef={this.saveFormRef}
					visible={this.state.visible}
					onCancel={this.handleCancel}
					onCreate={this.handleCreate}
					catalogId={this.state.catalogId}
					name={this.state.name}
					sku={sku}
					skus={skus}
				/>
				<React.Fragment>
					{!catalogId || catalogId == 0 ? (
						<div
							className="clickable"
							onClick={() => this.showModal(0)}>
							<CommunityButton
								text="Create New Stack / Collection"
								icon="icon-books"
								iconClass="small-save"
							/>
						</div>
					) : (
						<div
							className="clickable"
							onClick={() => this.showModal(catalogId, name)}>
							<CommunityButton
								text="Edit Name"
								icon="icon-note-icon"
								iconClass="small-save"
							/>
						</div>
					)}
				</React.Fragment>
			</React.Fragment>
		);
	}
}

const connectors = [connectToCollections, connectToTitle, connectToCatalog];

export default combineConnectors(connectors)(AddEditCollection);
